import React from 'react';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import { usePrevious } from '@gloat/hooks';

export const IntercomAPI = (...args) => {
  if (window.Intercom) {
    window.Intercom.apply(null, args);
  } else {
    console.warn('Intercom not initialized yet');
  }
};

export const showIntercom = () => IntercomAPI('show');
export const shutdownIntercom = () => IntercomAPI('shutdown');

export const parseUserPropsToIntercomProps = ({
  user: { firstName, lastName, email, imob, title, intercomId } = {},
} = {}) => {
  const userImobOrganizationName = imob?.organization?.name;
  const userImobOrganizationSlug = imob?.organization?.slug;

  return omitBy(
    {
      name: (firstName || lastName) && `${firstName}${lastName ? ' ' + lastName : ''}`,
      email,
      user_id: intercomId,
      title,
      imob: userImobOrganizationName,
      vertical_padding: 100,
      slug: userImobOrganizationSlug,
    },
    isUndefined,
  );
};

export const Intercom = ({ user, appID, shouldHideChat }) => {
  React.useEffect(() => {
    return () => {
      window.Intercom('shutdown');

      delete window.Intercom;
    };
  }, []);

  const intercomProps = {
    ...parseUserPropsToIntercomProps({ user }),
    hide_default_launcher: shouldHideChat || window.innerWidth <= 767,
    app_id: appID,
  };

  const prevAppId = usePrevious(appID);
  const prevUser = usePrevious(user);

  const init = ({ appID }) => {
    if (!window.Intercom) {
      (function (w, d, id, s) {
        function i() {
          i.c(arguments);
        }

        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        s = d.createElement('script');
        s.async = 1;
        s.src = 'https://widget.intercom.io/widget/' + id;
        d.head.appendChild(s);
      })(window, document, appID);
    }

    window.intercomSettings = intercomProps;

    if (window.Intercom) {
      window.Intercom('boot', intercomProps);
    }
  };

  React.useEffect(() => {
    if (prevAppId !== appID && appID) {
      init({ appID });
    }

    window.intercomSettings = intercomProps;

    if (!isEmpty(prevUser) && appID && window.Intercom) {
      window.Intercom('update', intercomProps);
    }
  }, [user, appID, shouldHideChat]);

  return null;
};

export default Intercom;
